import {css} from '@emotion/react'
import InputNumber from '@/components/Form/InputNumber.jsx'

import {
    PropertiesController,
    usePropertiesController,
} from './PropertiesController.jsx'

const cssNumber = css({
    textAlign: 'left',
})

export default function PropertiesControllerNumber({
    className,
    style,
    disabled,
    hidden,
    label,
    labelSuffix,
    prop,
    required,
    readOnly,
    value,
    ...props
}) {
    const p = usePropertiesController({
        disabled,
        hidden,
        label,
        prop,
        readOnly,
        required,
        value,
    })

    return (
        <PropertiesController
            className={className}
            style={style}
            error={p.error}
            hidden={p.hidden}
            label={p.label}
            labelSuffix={labelSuffix}
            required={p.required}
        >
            <InputNumber
                css={cssNumber}
                allowClear
                disabled={p.disabled}
                readOnly={p.readOnly}
                value={p.value}
                onBlur={p.onBlur}
                onChange={p.onChange}
                onFocus={p.onFocus}
                {...props}
            />
        </PropertiesController>
    )
}
